<script setup lang="ts">
    import { ref } from 'vue'
    import { storeToRefs } from 'pinia'

    import { Country, Status, FilterItem } from '~/js/interfaces/typesense';
    import { getClasses } from '~/js/composables/classes'
    import { getGlobalTranslation } from '~/js/composables/translations';
    import { useLocationsState } from '~/js/stores/locations';

    import FieldsetLocationFilter from '~/vue/molecules/fieldsets/FieldsetLocationFilter.vue'
    import FieldsetStatusFilter from '~/vue/molecules/fieldsets/FieldsetStatusFilter.vue'

    interface Filter {
        type: string;
        values: Array<number|string>;
    }

    interface Props {
        countries: Array<Country|null>|null
        defaultCountries: Array<number|null>
        defaultStatusses: Array<number|null>
        statusses: Array<Status|null>|null
        utilities?: string|null
    }

    const props = withDefaults(defineProps<Props>(), {utilities: ''})
    const emit = defineEmits(['search'])

    const locationsStore = useLocationsState()
    const { filters } = storeToRefs(locationsStore)
    const openFilter = ref<string|null>(null)

    const classes = {
    color: 'bg-blue-500',
    display: 'grid grid-cols-1 md:grid-cols-4',
    spacing: 'p-2 gap-2',
}

    const data = ref<Filter[]>([
        {
            type: 'statusses',
            values: props.defaultStatusses as Array<number | string>
        },
        {
            type: 'countries',
            values: props.defaultCountries as Array<number | string>
        }
    ])

    const onToggleDropdown = (value: string|null) => {
        openFilter.value = value ?? null
    }

    const onHandleInput = (input: string) => {
        filters.value.searchQuery = input
        
        onSearch(false)
    }

    const onHandleFilter = (filterItem: FilterItem) => {
        const filter: Filter | undefined = data.value.find(val => val.type == filterItem.type)

        if (filter) {
            filter.values = filterItem.values

            onSearch(false)
        }
    }

    const onSearch = scrollTo => {
        emit('search', scrollTo)
    }
</script>

<template>
    <form 
        :class="[
            getClasses(classes),
            utilities
        ]"
        @submit.prevent="() => onSearch(true)"    
    >
        <FieldsetLocationFilter 
            v-if="countries"
            :disabled="false"
            :label="getGlobalTranslation('Countries')"
            :options="countries" 
            @active-dropdown="onToggleDropdown($event)"
            @input="onHandleFilter($event)"
            dropdown-position="left"
            type="countries"
            utilities="md:col-span-2"
        />

        <FieldsetStatusFilter 
            v-if="statusses"
            :disabled="false"
            :label="getGlobalTranslation('Statusses')"
            :options="statusses" 
            @active-dropdown="onToggleDropdown($event)"
            @input="onHandleFilter($event)"
            dropdown-position="left"
            type="statusses"
            utilities="md:col-span-2"
        />
    </form>
</template>